import { inject } from '@angular/core'
import { RedirectCommand, Router, UrlTree } from '@angular/router'

import { AuthenticationService } from '@/app/core/service/auth.service'

export const authGuard = () => {
  const currentUser = inject(AuthenticationService).session
  const router: Router = inject(Router)

  if (currentUser) return true

  const urlTree: UrlTree = router.parseUrl('/auth/log-in')
  return new RedirectCommand(urlTree, { skipLocationChange: true })
}
